export default "assets/images/icons/error-4ffedc6a.svg";